import React, { useEffect, useState } from 'react';
import ForestIcon from '@mui/icons-material/Forest';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { useAtomValue, useSetAtom } from 'jotai';
import { default as getEnvContraintes } from '@/envContraintes';
import { envContraintesState, isDrawingState, validatedParcellesState } from '@/store';
import theme from '@/theme';

export default function SearchConstraints() {
  const parcellesFC = useAtomValue(validatedParcellesState);

  const isDrawing = useAtomValue(isDrawingState);

  const setEnvContraintes = useSetAtom(envContraintesState);

  const [isLoading, setIsLoading] = useState(false);

  const [disableSearch, setDisableSearch] = useState(true);

  useEffect(() => {
    if (isDrawing) {
      setDisableSearch(true);
      return;
    }

    setDisableSearch(parcellesFC.features.length === 0);
  }, [parcellesFC, isDrawing]);

  const onClick = async () => {
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    const intersectedEnvConstraints = await getEnvContraintes();

    setIsLoading(false);

    setEnvContraintes(intersectedEnvConstraints);
  };

  return (
    <Paper
      elevation={4}
      sx={{
        p: '2px',
        backgroundColor: disableSearch ? 'grey.50' : theme.palette.secondary.main,
      }}
    >
      <IconButton
        aria-label="analyze-constraints"
        title="Analyser les enjeux environnementaux"
        disabled={disableSearch}
        onClick={onClick}
      >
        {isLoading ? (
          <CircularProgress size={24} style={{ color: disableSearch ? null : '#fff' }} />
        ) : (
          <ForestIcon style={{ color: disableSearch ? null : '#fff' }} />
        )}
      </IconButton>
    </Paper>
  );
}
